import { render, staticRenderFns } from "./ExternalPluginSettings.vue?vue&type=template&id=595b3eb3&scoped=true"
import script from "./ExternalPluginSettings.vue?vue&type=script&lang=js"
export * from "./ExternalPluginSettings.vue?vue&type=script&lang=js"
import style0 from "./ExternalPluginSettings.vue?vue&type=style&index=0&id=595b3eb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595b3eb3",
  null
  
)

export default component.exports